import { useTheme } from '@mui/material';

export const RealWorldEvidenceIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={41} height={40} fill="none">
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4.5 3.5v7.625M37 34H4.5V22.562"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="m8.5 27 4-4 2.5 2.5 5.5-5.5"
            />
            <circle
                cx={26.909}
                cy={13.159}
                r={5.75}
                stroke={primaryStroke}
                strokeWidth={1.5}
                transform="rotate(-45 26.909 13.159)"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="m31.152 17.402 3.535 3.535m-6.01-9.546-3.536 3.536"
            />
        </svg>
    );
};
